import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks";
import { ArrowLeftIcon } from "../../../../../ui/icons/arrowLeft";
import Button from "../../../../../ui/molecules/button";
import { Spinner } from "../../../../../ui/molecules/spinner";
import { PersonDTO } from "../../../../database/people/dto";
import { ContactStateEnum } from "../../../dto";

export function NotConfirm({ setStep, listIndex, isLoading, handleConfirm, person }: {
    setStep: (step: number) => void, listIndex: number, isLoading: boolean
    handleConfirm: (outcome: ContactStateEnum, outcomeInfo: string | null) => void;
    person: PersonDTO
}) {
    const contactState = useAppSelector(state => state.contacts);
    const dispatch = useAppDispatch();
    const fullName = ` ${person?.name} ${person?.surname}`;

    return (
        <>
            <p className="text-text-md font-medium text-neutral-600 text-center max-w-md">
                Cliccando su "Conferma" prenderai in carico il lead senza verificare il consenso alla Privacy.
                <br />
                <br />
                Sei sicuro di voler procedere?
                <br />
            </p>
            <div className="flex w-3/4 items-center gap-4">
                <div className="flex-1">
                    <Button icon={<ArrowLeftIcon color={""} size={0} />} size={"sm"} iconPosition={"left"} variant={"outline"} color={"blue"} label="Verifica OTP" onClick={() => { setStep(1) }} fullWidth />
                </div>
                {
                    isLoading ?
                        <div className="flex-1 flex items-center justify-center">
                            <Spinner color="green" size={32} />
                        </div> :
                        <div className="flex-1">
                            <Button size={"sm"} iconPosition={"left"} variant={"solid"} color={"green"} label="Conferma" fullWidth
                                onClick={() =>
                                    handleConfirm(ContactStateEnum.LEADTAKEN, null)}
                            />
                        </div>
                }
            </div>
        </>
    );
}